import { default as aboutQa1sruZgmYMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventslGaN4NTCQMMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93ASUla7HkzmMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleYba5HRDk1yMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsMRSiumi5xIMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93HluAiP7lMpMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewGs04WJkxI1Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexwxv5K0OwDgMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_936pyQ9UVWhoMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexEJtcmvaf7FMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93ebg1dotyodMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexiLBeb8BjjZMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsYgXEVL0nWAMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsqu6J0c8MEKMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews43nN6CuqO3Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93XSk0d4ovGLMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexcGZm1h3b1HMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmpmqBbJYjblMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirm9lPFsaBwAZMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarjhFIWIpW20Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatr3ZnB4B7m7Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutIanaNHGvDeMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedp3YJCM12C3Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersqI0XLgCn0nMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93RU9Z4KnPeQMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editFG46APVMPaMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93LrZC6GolAnMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityjFmjtOd4LoMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_935CcukPX6tAMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93qRKOmx7JmWMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboarddNJveKbPtIMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexnekECfyEGFMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutMvsGrHJ8qvMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productqyFKbCq2qJMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsR4V0Nc8IyrMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93XfPsJZfFrwMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexZ8wVUMGAG1Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93rKzHPnKnwzMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_931A1fYe4aCaMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexWB09B4A346Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93E5MkAICUERMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinEw01CBrwSZMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/join.vue?macro=true";
import { default as loginxEG7BaOtehMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/login.vue?macro=true";
import { default as logoutcQmsh4WLblMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93T3t642ow0OMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93cqhYl2gxDwMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93VWfMdJIPXCMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoriteswwvPgWoAxTMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosW9JUTF79nwMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinYdJBaENrD4Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_934c10lQ02yHMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexDP7sH0Ixo0Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as index5E1Jd7vMBgMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutuRLgltkqIcMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contente5LTxsjTYxMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventstsUTsaf74GMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93wdeq4Vb23pMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplegL3OQsa6j8Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productslmwgEIBaIdMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93tyCvxxcu41Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewjLNbgxvceOMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index4zG2TYhn8eMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93vaGi2W7mIYMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indextGuqY5qTrMMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93rWQ4vh0uIoMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexcUhCZp95Z2Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsmai8EXobayMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsyuLciGhLWKMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewscYC8htA4jLMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_9369T2txtUGSMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexkmr4KsWJY5Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexjdoreQNxmVMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesQn0ipHTmScMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsBtQjp2nRrIMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93GeyzzAZ75QMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_937F3BJ9J8cvMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetR38shwlbw3Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/reset.vue?macro=true";
import { default as shopkoiV7F4T9OMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/shop.vue?macro=true";
import { default as signupYqt0H8g8DoMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/signup.vue?macro=true";
import { default as liveULzBLwYyJ3Meta } from "/tmp/build_5e3ab85d/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsIic4HkKWfPMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93iCEY6G1lUTMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactmz6lWprvQCMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullZXGKoDeMxrMeta } from "/tmp/build_5e3ab85d/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93XSk0d4ovGLMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93XSk0d4ovGLMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93XSk0d4ovGLMeta || {},
    alias: _91product_id_93XSk0d4ovGLMeta?.alias || [],
    redirect: _91product_id_93XSk0d4ovGLMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutQa1sruZgmYMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutQa1sruZgmYMeta?.path ?? "about",
    meta: aboutQa1sruZgmYMeta || {},
    alias: aboutQa1sruZgmYMeta?.alias || [],
    redirect: aboutQa1sruZgmYMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventslGaN4NTCQMMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventslGaN4NTCQMMeta?.path ?? "events",
    meta: eventslGaN4NTCQMMeta || {},
    alias: eventslGaN4NTCQMMeta?.alias || [],
    redirect: eventslGaN4NTCQMMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ASUla7HkzmMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93ASUla7HkzmMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93ASUla7HkzmMeta || {},
    alias: _91media_id_93ASUla7HkzmMeta?.alias || [],
    redirect: _91media_id_93ASUla7HkzmMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleYba5HRDk1yMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleYba5HRDk1yMeta?.path ?? "free-sample",
    meta: free_45sampleYba5HRDk1yMeta || {},
    alias: free_45sampleYba5HRDk1yMeta?.alias || [],
    redirect: free_45sampleYba5HRDk1yMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsMRSiumi5xIMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsMRSiumi5xIMeta?.path ?? "included-products",
    meta: included_45productsMRSiumi5xIMeta || {},
    alias: included_45productsMRSiumi5xIMeta?.alias || [],
    redirect: included_45productsMRSiumi5xIMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93HluAiP7lMpMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93HluAiP7lMpMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93HluAiP7lMpMeta || {},
    alias: _91media_id_93HluAiP7lMpMeta?.alias || [],
    redirect: _91media_id_93HluAiP7lMpMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewGs04WJkxI1Meta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewGs04WJkxI1Meta?.path ?? "lessons/:lesson_id()/view",
    meta: viewGs04WJkxI1Meta || {},
    alias: viewGs04WJkxI1Meta?.alias || [],
    redirect: viewGs04WJkxI1Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexwxv5K0OwDgMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexwxv5K0OwDgMeta?.path ?? "lessons",
    meta: indexwxv5K0OwDgMeta || {},
    alias: indexwxv5K0OwDgMeta?.alias || [],
    redirect: indexwxv5K0OwDgMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_936pyQ9UVWhoMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_936pyQ9UVWhoMeta?.path ?? "media/:media_id()",
    meta: _91media_id_936pyQ9UVWhoMeta || {},
    alias: _91media_id_936pyQ9UVWhoMeta?.alias || [],
    redirect: _91media_id_936pyQ9UVWhoMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexEJtcmvaf7FMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexEJtcmvaf7FMeta?.path ?? "playlists/:playlist_id()",
    meta: indexEJtcmvaf7FMeta || {},
    alias: indexEJtcmvaf7FMeta?.alias || [],
    redirect: indexEJtcmvaf7FMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93ebg1dotyodMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93ebg1dotyodMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93ebg1dotyodMeta || {},
    alias: _91media_id_93ebg1dotyodMeta?.alias || [],
    redirect: _91media_id_93ebg1dotyodMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexiLBeb8BjjZMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexiLBeb8BjjZMeta?.path ?? "playlists",
    meta: indexiLBeb8BjjZMeta || {},
    alias: indexiLBeb8BjjZMeta?.alias || [],
    redirect: indexiLBeb8BjjZMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsYgXEVL0nWAMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsYgXEVL0nWAMeta?.path ?? "private-sessions",
    meta: private_45sessionsYgXEVL0nWAMeta || {},
    alias: private_45sessionsYgXEVL0nWAMeta?.alias || [],
    redirect: private_45sessionsYgXEVL0nWAMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsqu6J0c8MEKMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsqu6J0c8MEKMeta?.path ?? "recordings",
    meta: recordingsqu6J0c8MEKMeta || {},
    alias: recordingsqu6J0c8MEKMeta?.alias || [],
    redirect: recordingsqu6J0c8MEKMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews43nN6CuqO3Meta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviews43nN6CuqO3Meta?.path ?? "reviews",
    meta: reviews43nN6CuqO3Meta || {},
    alias: reviews43nN6CuqO3Meta?.alias || [],
    redirect: reviews43nN6CuqO3Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexcGZm1h3b1HMeta?.name ?? "buy-product-product_id",
    path: indexcGZm1h3b1HMeta?.path ?? "/buy/product/:product_id()",
    meta: indexcGZm1h3b1HMeta || {},
    alias: indexcGZm1h3b1HMeta?.alias || [],
    redirect: indexcGZm1h3b1HMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmpmqBbJYjblMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmpmqBbJYjblMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmpmqBbJYjblMeta || {},
    alias: confirmpmqBbJYjblMeta?.alias || [],
    redirect: confirmpmqBbJYjblMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirm9lPFsaBwAZMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirm9lPFsaBwAZMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirm9lPFsaBwAZMeta || {},
    alias: confirm9lPFsaBwAZMeta?.alias || [],
    redirect: confirm9lPFsaBwAZMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarjhFIWIpW20Meta?.name ?? "calendar",
    path: calendarjhFIWIpW20Meta?.path ?? "/calendar",
    meta: calendarjhFIWIpW20Meta || {},
    alias: calendarjhFIWIpW20Meta?.alias || [],
    redirect: calendarjhFIWIpW20Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatr3ZnB4B7m7Meta?.name ?? "chat",
    path: chatr3ZnB4B7m7Meta?.path ?? "/chat",
    meta: chatr3ZnB4B7m7Meta || {},
    alias: chatr3ZnB4B7m7Meta?.alias || [],
    redirect: chatr3ZnB4B7m7Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93RU9Z4KnPeQMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93RU9Z4KnPeQMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93RU9Z4KnPeQMeta || {},
    alias: _91group_id_93RU9Z4KnPeQMeta?.alias || [],
    redirect: _91group_id_93RU9Z4KnPeQMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutIanaNHGvDeMeta?.name ?? "community-groups-group_id-about",
    path: aboutIanaNHGvDeMeta?.path ?? "about",
    meta: aboutIanaNHGvDeMeta || {},
    alias: aboutIanaNHGvDeMeta?.alias || [],
    redirect: aboutIanaNHGvDeMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedp3YJCM12C3Meta?.name ?? "community-groups-group_id-feed",
    path: feedp3YJCM12C3Meta?.path ?? "feed",
    meta: feedp3YJCM12C3Meta || {},
    alias: feedp3YJCM12C3Meta?.alias || [],
    redirect: feedp3YJCM12C3Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersqI0XLgCn0nMeta?.name ?? "community-groups-group_id-members",
    path: membersqI0XLgCn0nMeta?.path ?? "members",
    meta: membersqI0XLgCn0nMeta || {},
    alias: membersqI0XLgCn0nMeta?.alias || [],
    redirect: membersqI0XLgCn0nMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editFG46APVMPaMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editFG46APVMPaMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editFG46APVMPaMeta || {},
    alias: community_45profile_45editFG46APVMPaMeta?.alias || [],
    redirect: community_45profile_45editFG46APVMPaMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93LrZC6GolAnMeta?.name ?? "community-profile-id",
    path: _91id_93LrZC6GolAnMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93LrZC6GolAnMeta || {},
    alias: _91id_93LrZC6GolAnMeta?.alias || [],
    redirect: _91id_93LrZC6GolAnMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityjFmjtOd4LoMeta?.name ?? "community",
    path: communityjFmjtOd4LoMeta?.path ?? "/community",
    meta: communityjFmjtOd4LoMeta || {},
    alias: communityjFmjtOd4LoMeta?.alias || [],
    redirect: communityjFmjtOd4LoMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_935CcukPX6tAMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_935CcukPX6tAMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_935CcukPX6tAMeta || {},
    alias: _91uuid_935CcukPX6tAMeta?.alias || [],
    redirect: _91uuid_935CcukPX6tAMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93qRKOmx7JmWMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93qRKOmx7JmWMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93qRKOmx7JmWMeta || {},
    alias: _91unique_id_93qRKOmx7JmWMeta?.alias || [],
    redirect: _91unique_id_93qRKOmx7JmWMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboarddNJveKbPtIMeta?.name ?? "dashboard",
    path: dashboarddNJveKbPtIMeta?.path ?? "/dashboard",
    meta: dashboarddNJveKbPtIMeta || {},
    alias: dashboarddNJveKbPtIMeta?.alias || [],
    redirect: dashboarddNJveKbPtIMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexnekECfyEGFMeta?.name ?? "event-details-event_id",
    path: indexnekECfyEGFMeta?.path ?? "/event/details/:event_id()",
    meta: indexnekECfyEGFMeta || {},
    alias: indexnekECfyEGFMeta?.alias || [],
    redirect: indexnekECfyEGFMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutMvsGrHJ8qvMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutMvsGrHJ8qvMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutMvsGrHJ8qvMeta || {},
    alias: checkoutMvsGrHJ8qvMeta?.alias || [],
    redirect: checkoutMvsGrHJ8qvMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productqyFKbCq2qJMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productqyFKbCq2qJMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productqyFKbCq2qJMeta || {},
    alias: select_45productqyFKbCq2qJMeta?.alias || [],
    redirect: select_45productqyFKbCq2qJMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsR4V0Nc8IyrMeta?.name ?? "events",
    path: eventsR4V0Nc8IyrMeta?.path ?? "/events",
    meta: eventsR4V0Nc8IyrMeta || {},
    alias: eventsR4V0Nc8IyrMeta?.alias || [],
    redirect: eventsR4V0Nc8IyrMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93XfPsJZfFrwMeta?.name ?? "gifts-uuid",
    path: _91uuid_93XfPsJZfFrwMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93XfPsJZfFrwMeta || {},
    alias: _91uuid_93XfPsJZfFrwMeta?.alias || [],
    redirect: _91uuid_93XfPsJZfFrwMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexZ8wVUMGAG1Meta?.name ?? "gifts",
    path: indexZ8wVUMGAG1Meta?.path ?? "/gifts",
    meta: indexZ8wVUMGAG1Meta || {},
    alias: indexZ8wVUMGAG1Meta?.alias || [],
    redirect: indexZ8wVUMGAG1Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93rKzHPnKnwzMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93rKzHPnKnwzMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93rKzHPnKnwzMeta || {},
    alias: _91invitation_id_93rKzHPnKnwzMeta?.alias || [],
    redirect: _91invitation_id_93rKzHPnKnwzMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_931A1fYe4aCaMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_931A1fYe4aCaMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_931A1fYe4aCaMeta || {},
    alias: _91product_id_931A1fYe4aCaMeta?.alias || [],
    redirect: _91product_id_931A1fYe4aCaMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexWB09B4A346Meta?.name ?? "index",
    path: indexWB09B4A346Meta?.path ?? "/",
    meta: indexWB09B4A346Meta || {},
    alias: indexWB09B4A346Meta?.alias || [],
    redirect: indexWB09B4A346Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93E5MkAICUERMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93E5MkAICUERMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93E5MkAICUERMeta || {},
    alias: _91invitation_unique_id_93E5MkAICUERMeta?.alias || [],
    redirect: _91invitation_unique_id_93E5MkAICUERMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinEw01CBrwSZMeta?.name ?? "join",
    path: joinEw01CBrwSZMeta?.path ?? "/join",
    meta: joinEw01CBrwSZMeta || {},
    alias: joinEw01CBrwSZMeta?.alias || [],
    redirect: joinEw01CBrwSZMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginxEG7BaOtehMeta?.name ?? "login",
    path: loginxEG7BaOtehMeta?.path ?? "/login",
    meta: loginxEG7BaOtehMeta || {},
    alias: loginxEG7BaOtehMeta?.alias || [],
    redirect: loginxEG7BaOtehMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutcQmsh4WLblMeta?.name ?? "logout",
    path: logoutcQmsh4WLblMeta?.path ?? "/logout",
    meta: logoutcQmsh4WLblMeta || {},
    alias: logoutcQmsh4WLblMeta?.alias || [],
    redirect: logoutcQmsh4WLblMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93T3t642ow0OMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93T3t642ow0OMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93T3t642ow0OMeta || {},
    alias: _91meeting_type_slug_93T3t642ow0OMeta?.alias || [],
    redirect: _91meeting_type_slug_93T3t642ow0OMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93cqhYl2gxDwMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93cqhYl2gxDwMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93cqhYl2gxDwMeta || {},
    alias: _91meeting_unique_id_93cqhYl2gxDwMeta?.alias || [],
    redirect: _91meeting_unique_id_93cqhYl2gxDwMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93VWfMdJIPXCMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93VWfMdJIPXCMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93VWfMdJIPXCMeta || {},
    alias: _91meeting_unique_id_93VWfMdJIPXCMeta?.alias || [],
    redirect: _91meeting_unique_id_93VWfMdJIPXCMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoriteswwvPgWoAxTMeta?.name ?? "my-favorites",
    path: my_45favoriteswwvPgWoAxTMeta?.path ?? "/my-favorites",
    meta: my_45favoriteswwvPgWoAxTMeta || {},
    alias: my_45favoriteswwvPgWoAxTMeta?.alias || [],
    redirect: my_45favoriteswwvPgWoAxTMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosW9JUTF79nwMeta?.name ?? "my-studios",
    path: my_45studiosW9JUTF79nwMeta?.path ?? "/my-studios",
    meta: my_45studiosW9JUTF79nwMeta || {},
    alias: my_45studiosW9JUTF79nwMeta?.alias || [],
    redirect: my_45studiosW9JUTF79nwMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinYdJBaENrD4Meta?.name ?? "optin",
    path: optinYdJBaENrD4Meta?.path ?? "/optin",
    meta: optinYdJBaENrD4Meta || {},
    alias: optinYdJBaENrD4Meta?.alias || [],
    redirect: optinYdJBaENrD4Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_934c10lQ02yHMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_934c10lQ02yHMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_934c10lQ02yHMeta || {},
    alias: _91episode_id_934c10lQ02yHMeta?.alias || [],
    redirect: _91episode_id_934c10lQ02yHMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexDP7sH0Ixo0Meta?.name ?? "podcasts-podcast_id",
    path: indexDP7sH0Ixo0Meta?.path ?? "/podcasts/:podcast_id()",
    meta: indexDP7sH0Ixo0Meta || {},
    alias: indexDP7sH0Ixo0Meta?.alias || [],
    redirect: indexDP7sH0Ixo0Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: index5E1Jd7vMBgMeta?.name ?? "podcasts",
    path: index5E1Jd7vMBgMeta?.path ?? "/podcasts",
    meta: index5E1Jd7vMBgMeta || {},
    alias: index5E1Jd7vMBgMeta?.alias || [],
    redirect: index5E1Jd7vMBgMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_9369T2txtUGSMeta?.name ?? "product-product_id",
    path: _91product_id_9369T2txtUGSMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_9369T2txtUGSMeta || {},
    alias: _91product_id_9369T2txtUGSMeta?.alias || [],
    redirect: _91product_id_9369T2txtUGSMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutuRLgltkqIcMeta?.name ?? "product-product_id-about",
    path: aboutuRLgltkqIcMeta?.path ?? "about",
    meta: aboutuRLgltkqIcMeta || {},
    alias: aboutuRLgltkqIcMeta?.alias || [],
    redirect: aboutuRLgltkqIcMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contente5LTxsjTYxMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contente5LTxsjTYxMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contente5LTxsjTYxMeta || {},
    alias: digital_45download_45contente5LTxsjTYxMeta?.alias || [],
    redirect: digital_45download_45contente5LTxsjTYxMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventstsUTsaf74GMeta?.name ?? "product-product_id-events",
    path: eventstsUTsaf74GMeta?.path ?? "events",
    meta: eventstsUTsaf74GMeta || {},
    alias: eventstsUTsaf74GMeta?.alias || [],
    redirect: eventstsUTsaf74GMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93wdeq4Vb23pMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93wdeq4Vb23pMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93wdeq4Vb23pMeta || {},
    alias: _91media_id_93wdeq4Vb23pMeta?.alias || [],
    redirect: _91media_id_93wdeq4Vb23pMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplegL3OQsa6j8Meta?.name ?? "product-product_id-free-sample",
    path: free_45samplegL3OQsa6j8Meta?.path ?? "free-sample",
    meta: free_45samplegL3OQsa6j8Meta || {},
    alias: free_45samplegL3OQsa6j8Meta?.alias || [],
    redirect: free_45samplegL3OQsa6j8Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productslmwgEIBaIdMeta?.name ?? "product-product_id-included-products",
    path: included_45productslmwgEIBaIdMeta?.path ?? "included-products",
    meta: included_45productslmwgEIBaIdMeta || {},
    alias: included_45productslmwgEIBaIdMeta?.alias || [],
    redirect: included_45productslmwgEIBaIdMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93tyCvxxcu41Meta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93tyCvxxcu41Meta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93tyCvxxcu41Meta || {},
    alias: _91media_id_93tyCvxxcu41Meta?.alias || [],
    redirect: _91media_id_93tyCvxxcu41Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewjLNbgxvceOMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewjLNbgxvceOMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewjLNbgxvceOMeta || {},
    alias: viewjLNbgxvceOMeta?.alias || [],
    redirect: viewjLNbgxvceOMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index4zG2TYhn8eMeta?.name ?? "product-product_id-lessons",
    path: index4zG2TYhn8eMeta?.path ?? "lessons",
    meta: index4zG2TYhn8eMeta || {},
    alias: index4zG2TYhn8eMeta?.alias || [],
    redirect: index4zG2TYhn8eMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93vaGi2W7mIYMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93vaGi2W7mIYMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93vaGi2W7mIYMeta || {},
    alias: _91media_id_93vaGi2W7mIYMeta?.alias || [],
    redirect: _91media_id_93vaGi2W7mIYMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indextGuqY5qTrMMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indextGuqY5qTrMMeta?.path ?? "playlists/:playlist_id()",
    meta: indextGuqY5qTrMMeta || {},
    alias: indextGuqY5qTrMMeta?.alias || [],
    redirect: indextGuqY5qTrMMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93rWQ4vh0uIoMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93rWQ4vh0uIoMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93rWQ4vh0uIoMeta || {},
    alias: _91media_id_93rWQ4vh0uIoMeta?.alias || [],
    redirect: _91media_id_93rWQ4vh0uIoMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexcUhCZp95Z2Meta?.name ?? "product-product_id-playlists",
    path: indexcUhCZp95Z2Meta?.path ?? "playlists",
    meta: indexcUhCZp95Z2Meta || {},
    alias: indexcUhCZp95Z2Meta?.alias || [],
    redirect: indexcUhCZp95Z2Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsmai8EXobayMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsmai8EXobayMeta?.path ?? "private-sessions",
    meta: private_45sessionsmai8EXobayMeta || {},
    alias: private_45sessionsmai8EXobayMeta?.alias || [],
    redirect: private_45sessionsmai8EXobayMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsyuLciGhLWKMeta?.name ?? "product-product_id-recordings",
    path: recordingsyuLciGhLWKMeta?.path ?? "recordings",
    meta: recordingsyuLciGhLWKMeta || {},
    alias: recordingsyuLciGhLWKMeta?.alias || [],
    redirect: recordingsyuLciGhLWKMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewscYC8htA4jLMeta?.name ?? "product-product_id-reviews",
    path: reviewscYC8htA4jLMeta?.path ?? "reviews",
    meta: reviewscYC8htA4jLMeta || {},
    alias: reviewscYC8htA4jLMeta?.alias || [],
    redirect: reviewscYC8htA4jLMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexkmr4KsWJY5Meta?.name ?? "product",
    path: indexkmr4KsWJY5Meta?.path ?? "/product",
    meta: indexkmr4KsWJY5Meta || {},
    alias: indexkmr4KsWJY5Meta?.alias || [],
    redirect: indexkmr4KsWJY5Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexjdoreQNxmVMeta?.name ?? "profile",
    path: indexjdoreQNxmVMeta?.path ?? "/profile",
    meta: indexjdoreQNxmVMeta || {},
    alias: indexjdoreQNxmVMeta?.alias || [],
    redirect: indexjdoreQNxmVMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesQn0ipHTmScMeta?.name ?? "profile-purchases",
    path: purchasesQn0ipHTmScMeta?.path ?? "/profile/purchases",
    meta: purchasesQn0ipHTmScMeta || {},
    alias: purchasesQn0ipHTmScMeta?.alias || [],
    redirect: purchasesQn0ipHTmScMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsBtQjp2nRrIMeta?.name ?? "profile-redemptions",
    path: redemptionsBtQjp2nRrIMeta?.path ?? "/profile/redemptions",
    meta: redemptionsBtQjp2nRrIMeta || {},
    alias: redemptionsBtQjp2nRrIMeta?.alias || [],
    redirect: redemptionsBtQjp2nRrIMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93GeyzzAZ75QMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93GeyzzAZ75QMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93GeyzzAZ75QMeta || {},
    alias: _91quiz_id_93GeyzzAZ75QMeta?.alias || [],
    redirect: _91quiz_id_93GeyzzAZ75QMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_937F3BJ9J8cvMeta?.name ?? "reset-password-uid-token",
    path: _91token_937F3BJ9J8cvMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_937F3BJ9J8cvMeta || {},
    alias: _91token_937F3BJ9J8cvMeta?.alias || [],
    redirect: _91token_937F3BJ9J8cvMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetR38shwlbw3Meta?.name ?? "reset",
    path: resetR38shwlbw3Meta?.path ?? "/reset",
    meta: resetR38shwlbw3Meta || {},
    alias: resetR38shwlbw3Meta?.alias || [],
    redirect: resetR38shwlbw3Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopkoiV7F4T9OMeta?.name ?? "shop",
    path: shopkoiV7F4T9OMeta?.path ?? "/shop",
    meta: shopkoiV7F4T9OMeta || {},
    alias: shopkoiV7F4T9OMeta?.alias || [],
    redirect: shopkoiV7F4T9OMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupYqt0H8g8DoMeta?.name ?? "signup",
    path: signupYqt0H8g8DoMeta?.path ?? "/signup",
    meta: signupYqt0H8g8DoMeta || {},
    alias: signupYqt0H8g8DoMeta?.alias || [],
    redirect: signupYqt0H8g8DoMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveULzBLwYyJ3Meta?.name ?? "streaming-event_id-live",
    path: liveULzBLwYyJ3Meta?.path ?? "/streaming/:event_id()/live",
    meta: liveULzBLwYyJ3Meta || {},
    alias: liveULzBLwYyJ3Meta?.alias || [],
    redirect: liveULzBLwYyJ3Meta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsIic4HkKWfPMeta?.name ?? "tips",
    path: tipsIic4HkKWfPMeta?.path ?? "/tips",
    meta: tipsIic4HkKWfPMeta || {},
    alias: tipsIic4HkKWfPMeta?.alias || [],
    redirect: tipsIic4HkKWfPMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93iCEY6G1lUTMeta?.name ?? "waiver-uuid",
    path: _91uuid_93iCEY6G1lUTMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93iCEY6G1lUTMeta || {},
    alias: _91uuid_93iCEY6G1lUTMeta?.alias || [],
    redirect: _91uuid_93iCEY6G1lUTMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactmz6lWprvQCMeta?.name ?? "widgets-calendars-compact",
    path: compactmz6lWprvQCMeta?.path ?? "/widgets/calendars/compact",
    meta: compactmz6lWprvQCMeta || {},
    alias: compactmz6lWprvQCMeta?.alias || [],
    redirect: compactmz6lWprvQCMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullZXGKoDeMxrMeta?.name ?? "widgets-calendars-full",
    path: fullZXGKoDeMxrMeta?.path ?? "/widgets/calendars/full",
    meta: fullZXGKoDeMxrMeta || {},
    alias: fullZXGKoDeMxrMeta?.alias || [],
    redirect: fullZXGKoDeMxrMeta?.redirect,
    component: () => import("/tmp/build_5e3ab85d/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]